import React from 'react';
import { Grid } from '@mui/material';
import {
  Assessment,
  Security,
  Warning,
  TrendingUp,
} from '@mui/icons-material';
import { Analysis } from '../../types';
import { StatsCard } from '../dashboard';

interface AnalysisStatsCardsProps {
  analyses: Analysis[];
}

const AnalysisStatsCards: React.FC<AnalysisStatsCardsProps> = ({ analyses }) => {
  const avgConfidence = analyses.length > 0 
    ? Math.round(analyses.reduce((acc, a) => acc + a.confidence_score, 0) / analyses.length * 100)
    : 0;

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} sm={6} md={3}>
        <StatsCard
          title="Total Analyses"
          value={analyses.length}
          icon={<Assessment />}
          color="primary.main"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatsCard
          title="Counterfeits Detected"
          value={analyses.filter(a => a.is_counterfeit).length}
          icon={<Security />}
          color="error.main"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatsCard
          title="High Risk Items"
          value={analyses.filter(a => a.risk_level === 'high').length}
          icon={<Warning />}
          color="warning.main"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatsCard
          title="Avg Confidence"
          value={`${avgConfidence}%`}
          icon={<TrendingUp />}
          color="success.main"
        />
      </Grid>
    </Grid>
  );
};

export default AnalysisStatsCards;